import { render } from "./PayDeclined.vue?vue&type=template&id=20b4657a&ts=true"
import script from "./PayDeclined.vue?vue&type=script&lang=ts"
export * from "./PayDeclined.vue?vue&type=script&lang=ts"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__